import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { addReadingListItemWithURL } from '../utils/SafariReadingList';
import usePrevious from './usePrevious';
import useIsReadingListEnabled from './useIsReadingListEnabled';


const Metascraper = gql`query metascraper($url:AbsoluteUrl!){
  linkPreview(url:$url){
    description
    image
    title
  }
}`;

const useMetascraper = (link) => {
  const [fetch, state] = useLazyQuery(Metascraper),
        previousLink = usePrevious(link),
        [isReadingListEnabled] = useIsReadingListEnabled();

  useEffect(() => {
    if (link && previousLink !== link) {
      fetch({
        variables: { url: link },
      });
    }
  }, [fetch, link, previousLink]);

  useEffect(() => {
    if (state && state.data && isReadingListEnabled) {
      const { linkPreview: { title, description } } = state.data;
      addReadingListItemWithURL(
        link,
        title,
        description,
      );
    }
  }, [isReadingListEnabled, link, state]);

  return { data: link && state && state.data && state.data.linkPreview, loading: state.loading };
};

export default useMetascraper;
